/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
import React, { useState, useCallback, useEffect } from "react";
import { loadWeb3, getWeb3Instance } from "./Connectivity/Connectivity";
import { toast } from "react-toastify";
import {
  USDT,
  USDTAbi,
} from "./Contract";
import "bootstrap/dist/css/bootstrap.min.css";
import { tradeXNftMatrix, tradeXNftMatrixAbi } from "./Contract";
export default function Page1() {
  const [btnTxt, setBtnTxt] = useState("Connect Wallet");
  const [account, setAccount] = useState("");
  const [activeTab, setActiveTab] = useState("overview");
  const [loadingStates, setLoadingStates] = useState({});
 
  // Function inputs and outputs storage
  const [functionInputs, setFunctionInputs] = useState({});
  const [functionOutputs, setFunctionOutputs] = useState({});
 
  // Overview data
  const [matrixData, setMatrixData] = useState({
    totalUsers: "",
    totalLevel: "",
    directIncomePercent: "",
    levelIncomePercent: "",
    paused: false,
    usdtBalance: "",
    userUsdtBalance: ""
  });

  // Matrix contract functions definitions
  const matrixFunctions = {
    // Read Functions (View Functions)
    readFunctions: [
      {
        name: "burnIncomePercent",
        title: "Burn Income %",
        description: "Get the burn income percentage",
        inputs: [],
        icon: "🔥",
        category: "Income",
        formatOutput: (value) => `${value}%`
      },
      {
        name: "directIncomePercent",
        title: "Direct Income %",
        description: "Get the direct income percentage",
        inputs: [],
        icon: "💰",
        category: "Income",
        formatOutput: (value) => `${value}%`
      },
      {
        name: "findFreeReferrer",
        title: "Find Free Referrer",
        description: "Find a free referrer for a user",
        inputs: [
          { name: "_user", type: "address", placeholder: "Enter user address", required: true }
        ],
        icon: "🔍",
        category: "Tree Structure"
      },
      {
        name: "getFundEligible",
        title: "Get Fund Eligible",
        description: "Check if account is eligible for funds",
        inputs: [
          { name: "account", type: "address", placeholder: "Enter account address", required: true }
        ],
        icon: "✅",
        category: "User Info",
        formatOutput: (value) => value ? 'Yes' : 'No'
      },
      {
        name: "getIncomeAmount",
        title: "Get Income Amount",
        description: "Get income amount for level and income type",
        inputs: [
          { name: "level", type: "uint8", placeholder: "Enter level (uint8)", required: true },
          { name: "income", type: "uint8", placeholder: "Enter income type (uint8)", required: true }
        ],
        icon: "💰",
        category: "Income"
      },
      {
        name: "getPrincipleBurnAmount",
        title: "Get Principle Burn Amount",
        description: "Get the principle burn amount for the given account and amount",
        inputs: [
          { name: "account", type: "address", placeholder: "Enter account address", required: true },
          { name: "principleAmount", type: "uint256", placeholder: "Enter principle amount (uint256)", required: true }
        ],
        icon: "🔥",
        category: "Rewards"
      },
      {
        name: "getLevelTreeDetails",
        title: "Get Level Tree Details",
        description: "Get level tree details for user",
        inputs: [
          { name: "userAccount", type: "address", placeholder: "Enter user account address", required: true }
        ],
        icon: "🌲",
        category: "Tree Structure",
        formatOutput: (value) => {
          const firstUpline = value?.firstUpline ?? value?.[0] ?? "0x0";
          const downlines = Array.isArray(value?.downlines)
            ? value.downlines
            : Array.isArray(value?.[1])
              ? value[1]
              : [];
          const isReached = value?.isDownlineReached ?? value?.[2] ?? false;
          return `First Upline: ${firstUpline}\nDownlines: ${downlines.length ? downlines.join(', ') : 'None'}\nIs Downline Reached: ${isReached ? 'Yes' : 'No'}`;
        }
      },
      {
        name: "getSaleDirectCondition",
        title: "Get Sale Direct Condition",
        description: "Get sale direct condition for tree line",
        inputs: [
          { name: "treeLine", type: "uint256", placeholder: "Enter tree line (uint256)", required: true }
        ],
        icon: "📊",
        category: "Conditions"
      },
      {
        name: "getSubDirectCondition",
        title: "Get Sub Direct Condition",
        description: "Get sub direct condition for tree line",
        inputs: [
          { name: "treeLine", type: "uint256", placeholder: "Enter tree line (uint256)", required: true }
        ],
        icon: "📊",
        category: "Conditions"
      },
      {
        name: "getTeamSize",
        title: "Get Team Size",
        description: "Get team size for account with required size",
        inputs: [
          { name: "account", type: "address", placeholder: "Enter account address", required: true },
          { name: "requireSize", type: "uint256", placeholder: "Enter required size (uint256)", required: true }
        ],
        icon: "👥",
        category: "User Info"
      },
      {
        name: "getTotalRewardChunk",
        title: "Get Total Reward Chunk",
        description: "Get total reward chunk for account and amount",
        inputs: [
          { name: "account", type: "address", placeholder: "Enter account address", required: true },
          { name: "amount", type: "uint256", placeholder: "Enter amount (uint256)", required: true }
        ],
        icon: "💰",
        category: "Rewards"
      },
      {
        name: "getUserDownline",
        title: "Get User Downline",
        description: "Get user's downlines",
        inputs: [
          { name: "account", type: "address", placeholder: "Enter account address", required: true }
        ],
        icon: "🌳",
        category: "User Info",
        formatOutput: (value) => value.join(', ') || 'None'
      },
      {
        name: "getUserHoldingLimit",
        title: "Get User Holding Limit",
        description: "Get user's holding limit based on current level",
        inputs: [
          { name: "account", type: "address", placeholder: "Enter account address", required: true }
        ],
        icon: "📋",
        category: "User Info"
      },
      {
        name: "getUserLevelStatus",
        title: "Get User Level Status",
        description: "Check if user has reached or exceeded the level",
        inputs: [
          { name: "account", type: "address", placeholder: "Enter account address", required: true },
          { name: "level", type: "uint8", placeholder: "Enter level (uint8)", required: true }
        ],
        icon: "🎯",
        category: "User Info",
        formatOutput: (value) => value ? 'Yes' : 'No'
      },
      {
        name: "getUserPlanLimt",
        title: "Get User Plan Limit",
        description: "Get user's plan limit based on current level",
        inputs: [
          { name: "account", type: "address", placeholder: "Enter account address", required: true }
        ],
        icon: "📋",
        category: "User Info"
      },
      {
        name: "globalNftLimitPeriod",
        title: "Global NFT Limit Period",
        description: "Get the global NFT limit period",
        inputs: [],
        icon: "⏱️",
        category: "Basic Info"
      },
      {
        name: "holdingMax",
        title: "Holding Max",
        description: "Get the maximum holding multiplier",
        inputs: [],
        icon: "📈",
        category: "Basic Info"
      },
      {
        name: "idToAddress",
        title: "ID To Address",
        description: "Get address from user ID",
        inputs: [
          { name: "arg0", type: "uint256", placeholder: "Enter user ID (uint256)", required: true }
        ],
        icon: "🆔",
        category: "Mappings"
      },
      {
        name: "isBotStatus",
        title: "Is Bot Status",
        description: "Check bot status for account",
        inputs: [
          { name: "arg0", type: "address", placeholder: "Enter account address", required: true }
        ],
        icon: "🤖",
        category: "User Info",
        formatOutput: (value) => value ? 'Yes' : 'No'
      },
      {
        name: "isUserExists",
        title: "Is User Exists",
        description: "Check if user exists in the system",
        inputs: [
          { name: "account", type: "address", placeholder: "Enter account address", required: true }
        ],
        icon: "🔍",
        category: "User Info",
        formatOutput: (value) => value ? 'Yes' : 'No'
      },
      {
        name: "isUserSubscribed",
        title: "Is User Subscribed",
        description: "Check if user is subscribed",
        inputs: [
          { name: "account", type: "address", placeholder: "Enter account address", required: true }
        ],
        icon: "✅",
        category: "User Info",
        formatOutput: (value) => value ? 'Yes' : 'No'
      },
      {
        name: "lastUserAddress",
        title: "Last User Address",
        description: "Get the address of the last registered user",
        inputs: [],
        icon: "👤",
        category: "User Info"
      },
      {
        name: "levelIncomePercent",
        title: "Level Income %",
        description: "Get the level income percentage",
        inputs: [],
        icon: "📊",
        category: "Income",
        formatOutput: (value) => `${value}%`
      },
      {
        name: "levelIncomeThresholds",
        title: "Level Income Thresholds",
        description: "Get level income threshold at index",
        inputs: [
          { name: "arg0", type: "uint256", placeholder: "Enter index (uint256)", required: true }
        ],
        icon: "📈",
        category: "Income"
      },
      {
        name: "lpIncomePercent",
        title: "LP Income %",
        description: "Get the LP income percentage",
        inputs: [],
        icon: "💧",
        category: "Income",
        formatOutput: (value) => `${value}%`
      },
      {
        name: "lpReward",
        title: "LP Reward",
        description: "Get the LP reward contract address",
        inputs: [],
        icon: "🏆",
        category: "Basic Info"
      },
      {
        name: "nftMarketPlace",
        title: "NFT Market Place",
        description: "Get the NFT marketplace address",
        inputs: [],
        icon: "🎨",
        category: "Basic Info"
      },
      {
        name: "nftReward",
        title: "NFT Reward",
        description: "Get the NFT reward contract address",
        inputs: [],
        icon: "🏆",
        category: "Basic Info"
      },
      {
        name: "owner",
        title: "Owner",
        description: "Get the contract owner address",
        inputs: [],
        icon: "👑",
        category: "Basic Info"
      },
      {
        name: "pair",
        title: "Pair",
        description: "Get the pair address",
        inputs: [],
        icon: "🔗",
        category: "Basic Info"
      },
      {
        name: "paused",
        title: "Paused",
        description: "Check if the contract is paused",
        inputs: [],
        icon: "⏸️",
        category: "Basic Info",
        formatOutput: (value) => value ? 'Yes' : 'No'
      },
      {
        name: "planInfo",
        title: "Plan Info",
        description: "Get plan information for a level",
        inputs: [
          { name: "arg0", type: "uint8", placeholder: "Enter level (uint8)", required: true }
        ],
        icon: "📋",
        category: "Pricing",
        formatOutput: (value) => {
          const plan = value || {};
          return `Plan Price: ${plan.planPrice ?? plan[0] ?? '0'}\nPlan Limit: ${plan.planLimit ?? plan[1] ?? '0'}\nHolding NFT: ${plan.holdingNft ?? plan[2] ?? '0'}\nDirect Count: ${plan.directCount ?? plan[3] ?? '0'}`;
        }
      },
      {
        name: "platformIncomePercent",
        title: "Platform Income %",
        description: "Get the platform income percentage",
        inputs: [],
        icon: "🏢",
        category: "Income",
        formatOutput: (value) => `${value}%`
      },
      {
        name: "router",
        title: "Router",
        description: "Get the router address",
        inputs: [],
        icon: "🧭",
        category: "Basic Info"
      },
      {
        name: "saleNftDirectThresholds",
        title: "Sale NFT Direct Thresholds",
        description: "Get sale NFT direct threshold at index",
        inputs: [
          { name: "arg0", type: "uint256", placeholder: "Enter index (uint256)", required: true }
        ],
        icon: "📊",
        category: "Conditions"
      },
      {
        name: "saleNftLevelPercents",
        title: "Sale NFT Level Percents",
        description: "Get sale NFT level percent at index",
        inputs: [
          { name: "arg0", type: "uint256", placeholder: "Enter index (uint256)", required: true }
        ],
        icon: "📊",
        category: "Income",
        formatOutput: (value) => `${value}%`
      },
      {
        name: "topWallet",
        title: "Top Wallet",
        description: "Get the top wallet address",
        inputs: [],
        icon: "👛",
        category: "Basic Info"
      },
      {
        name: "totalLevel",
        title: "Total Level",
        description: "Get the total number of levels",
        inputs: [],
        icon: "🏆",
        category: "Basic Info"
      },
      {
        name: "totalUsers",
        title: "Total Users",
        description: "Get the total number of users",
        inputs: [],
        icon: "👥",
        category: "Stats"
      },
      // ✅ NEW: tradexRedeem (was missing)
      {
        name: "tradexRedeem",
        title: "Tradex Redeem",
        description: "Get the tradex redeem contract address",
        inputs: [],
        icon: "🔄",
        category: "Basic Info"
      },
      {
        name: "usdtToken",
        title: "USDT Token",
        description: "Get the USDT token address",
        inputs: [],
        icon: "💵",
        category: "Basic Info"
      },
      // ✅ NEW: userBotLevel (was missing)
      {
        name: "userBotLevel",
        title: "User Bot Level",
        description: "Get bot level for a user address",
        inputs: [
          { name: "arg0", type: "address", placeholder: "Enter user address", required: true }
        ],
        icon: "🤖",
        category: "User Info"
      },
      {
        name: "userHoldInfo",
        title: "User Hold Info",
        description: "Get user's holding information",
        inputs: [
          { name: "arg0", type: "address", placeholder: "Enter user address", required: true }
        ],
        icon: "📋",
        category: "User Info",
        formatOutput: (value) => {
          const info = value || {};
          const userTotalLimit = info.userTotalLimit ?? info[0] ?? '0';
          const totalRewardEarned = info.totalRewardEarned ?? info[1] ?? '0';
          const userLastDraw = info.userLastDraw ?? info[2] ?? '0';
          const userLastCycle = info.userLastCycle ?? info[3] ?? '0';
          const isExcludeCondition = info.isExcludeCondition ?? info[4] ?? false;
          const isBlocked = info.isBlocked ?? info[5] ?? false;
          const isResync = info.isResync ?? info[6] ?? false;
          const principleBurnCollected = info.principleBurnCollected ?? info[7] ?? '0';
          return `User Total Limit: ${userTotalLimit}\nTotal Reward Earned: ${totalRewardEarned}\nUser Last Draw: ${userLastDraw}\nUser Last Cycle: ${userLastCycle}\nIs Exclude Condition: ${isExcludeCondition ? 'Yes' : 'No'}\nIs Blocked: ${isBlocked ? 'Yes' : 'No'}\nIs Resync: ${isResync ? 'Yes' : 'No'}\nPrinciple Burn Collected: ${principleBurnCollected}`;
        }
      },
      {
        name: "userHoldingLevelAmount",
        title: "User Holding Level Amount",
        description: "Get user's holding level amount at index",
        inputs: [
          { name: "arg0", type: "address", placeholder: "Enter user address", required: true },
          { name: "arg1", type: "uint256", placeholder: "Enter index (uint256)", required: true }
        ],
        icon: "💰",
        category: "User Info"
      },
      {
        name: "userHoldingStatus",
        title: "User Holding Status",
        description: "Get user's holding status at index",
        inputs: [
          { name: "arg0", type: "address", placeholder: "Enter user address", required: true },
          { name: "arg1", type: "uint256", placeholder: "Enter index (uint256)", required: true }
        ],
        icon: "✅",
        category: "User Info",
        formatOutput: (value) => value ? 'Yes' : 'No'
      },
      {
        name: "userInfo",
        title: "User Info",
        description: "Get user's basic information",
        inputs: [
          { name: "arg0", type: "address", placeholder: "Enter user address", required: true }
        ],
        icon: "👤",
        category: "User Info",
        formatOutput: (value) => {
          const info = value || {};
          return `Current Level: ${info.currentLevel ?? info[0] ?? '0'}\nID: ${info.id ?? info[1] ?? '0'}\nDirect Count: ${info.directCount ?? info[2] ?? '0'}\nReward Earned: ${info.rewardEarned ?? info[3] ?? '0'}\nLast Time Stamp: ${info.lastTimeStamp ?? info[4] ?? '0'}\nDirect Referrer: ${info.directReferrer ?? info[5] ?? '0x0'}\nFirst Upline: ${info.firstUpline ?? info[6] ?? '0x0'}\nIs Downline Reached: ${info.isDownlineReached ?? info[7] ? 'Yes' : 'No'}`;
        }
      },
      {
        name: "userLevelHoldRequire",
        title: "User Level Hold Require",
        description: "Get the user level hold requirement",
        inputs: [],
        icon: "📋",
        category: "Conditions"
      }
    ],

    // Write Functions (Transaction Functions)
    writeFunctions: [
      {
        name: "subscribe",
        title: "Subscribe",
        description: "Subscribe with referrer and level",
        inputs: [
          { name: "referrer", type: "address", placeholder: "Enter referrer address", required: true },
          { name: "level", type: "uint8", placeholder: "Enter level (uint8)", required: true }
        ],
        requiresApproval: true,
        icon: "🚀",
        category: "User Actions"
      },
      {
        // ✅ FIXED: level parameter was missing before
        name: "botSubScribe",
        title: "Bot Subscribe",
        description: "Subscribe a bot user account with level",
        inputs: [
          { name: "userAccount", type: "address", placeholder: "Enter user account", required: true },
          { name: "level", type: "uint8", placeholder: "Enter level (uint8)", required: true }
        ],
        icon: "🤖",
        category: "User Actions"
      },
      {
        name: "nftSaleDistribute",
        title: "NFT Sale Distribute",
        description: "Distribute rewards from NFT sale (restricted to marketplace)",
        inputs: [
          { name: "tokenId", type: "uint256", placeholder: "Enter token ID (uint256)", required: true },
          { name: "currentDirect", type: "address", placeholder: "Enter current direct address", required: true },
          { name: "amount", type: "uint256", placeholder: "Enter amount (uint256)", required: true }
        ],
        icon: "🎨",
        category: "User Actions"
      },
      {
        name: "setNftLevelStatus",
        title: "Set NFT Level Status",
        description: "Set NFT level status for user (restricted to marketplace)",
        inputs: [
          { name: "userAccount", type: "address", placeholder: "Enter user account address", required: true },
          { name: "nftPrice", type: "uint256", placeholder: "Enter NFT price (uint256)", required: true }
        ],
        icon: "🎯",
        category: "User Actions"
      },
      {
        name: "setRewardAmount",
        title: "Set Reward Amount",
        description: "Set reward amount for account (restricted to marketplace)",
        inputs: [
          { name: "account", type: "address", placeholder: "Enter account address", required: true },
          { name: "amount", type: "uint256", placeholder: "Enter amount (uint256)", required: true }
        ],
        icon: "💰",
        category: "User Actions"
      },
      {
        name: "recordPrincipleBurn",
        title: "Record Principle Burn",
        description: "Record principle burn for account (restricted to marketplace)",
        inputs: [
          { name: "account", type: "address", placeholder: "Enter account address", required: true },
          { name: "amount", type: "uint256", placeholder: "Enter amount (uint256)", required: true }
        ],
        icon: "🔥",
        category: "User Actions"
      }
    ],

    // Admin Functions (onlyOwner)
    adminFunctions: [
      {
        name: "initialize",
        title: "Initialize",
        description: "Initialize the contract",
        inputs: [
          { name: "initialOwner", type: "address", placeholder: "Enter initial owner", required: true },
          { name: "nftMarketPlaceContract", type: "address", placeholder: "Enter NFT marketplace address", required: true }
        ],
        icon: "⚙️",
        category: "Admin Control"
      },
      {
        name: "addNewPakage",
        title: "Add New Package",
        description: "Add or update a package (admin only)",
        inputs: [
          { name: "index", type: "uint8", placeholder: "Enter index (uint8)", required: true },
          { name: "planPrice", type: "uint256", placeholder: "Enter plan price (uint256)", required: true },
          { name: "planLimit", type: "uint256", placeholder: "Enter plan limit (uint256)", required: true },
          { name: "holdingNft", type: "uint256", placeholder: "Enter holding NFT (uint256)", required: true },
          { name: "directCount", type: "uint256", placeholder: "Enter direct count (uint256)", required: true },
          { name: "newTotalLevel", type: "uint8", placeholder: "Enter new total level (uint8)", required: true }
        ],
        icon: "➕",
        category: "Admin Settings"
      },
      // ✅ NEW: changeUserAddress (was missing)
      {
        name: "changeUserAddress",
        title: "Change User Address",
        description: "Change a user's address to a new one (admin only)",
        inputs: [
          { name: "oldAddress", type: "address", placeholder: "Enter old user address", required: true },
          { name: "newAddress", type: "address", placeholder: "Enter new user address", required: true },
          { name: "holdCycles", type: "uint256[]", placeholder: "Enter hold cycles (comma separated)", required: true }
        ],
        icon: "🔀",
        category: "Admin Control"
      },
      {
        name: "pause",
        title: "Pause",
        description: "Pause the contract (admin only)",
        inputs: [],
        icon: "⏸️",
        category: "Admin Control"
      },
      {
        name: "unpause",
        title: "Unpause",
        description: "Unpause the contract (admin only)",
        inputs: [],
        icon: "▶️",
        category: "Admin Control"
      },
      {
        name: "renounceOwnership",
        title: "Renounce Ownership",
        description: "Renounce ownership (admin only)",
        inputs: [],
        icon: "👑",
        category: "Admin Control"
      },
      {
        name: "transferOwnership",
        title: "Transfer Ownership",
        description: "Transfer ownership to new address (admin only)",
        inputs: [
          { name: "newOwner", type: "address", placeholder: "Enter new owner address", required: true }
        ],
        icon: "🔄",
        category: "Admin Control"
      },
      {
        name: "setIncomePercent",
        title: "Set Income Percent",
        description: "Set income percentages (admin only)",
        inputs: [
          { name: "newDirectOne", type: "uint256", placeholder: "Enter new direct % (uint256)", required: true },
          { name: "newCurrLevel", type: "uint256", placeholder: "Enter new level % (uint256)", required: true },
          { name: "newPlatform", type: "uint256", placeholder: "Enter new platform % (uint256)", required: true },
          { name: "newBurnIncomePercent", type: "uint256", placeholder: "Enter new burn % (uint256)", required: true },
          { name: "newLpIncomePercent", type: "uint256", placeholder: "Enter new LP % (uint256)", required: true }
        ],
        icon: "💰",
        category: "Admin Settings"
      },
      {
        name: "setBotStatus",
        title: "Set Bot Status",
        description: "Set bot status for an account (admin only)",
        inputs: [
          { name: "account", type: "address", placeholder: "Enter account address", required: true },
          { name: "status", type: "bool", placeholder: "Enter status (true/false)", required: true }
        ],
        icon: "🤖",
        category: "Admin Settings"
      },
      {
        name: "setGlobalNftLimitPeriod",
        title: "Set Global NFT Limit Period",
        description: "Set global NFT limit period (admin only)",
        inputs: [
          { name: "newGlobalNftLimitPeriod", type: "uint256", placeholder: "Enter new period (uint256)", required: true }
        ],
        icon: "⏱️",
        category: "Admin Settings"
      },
      {
        name: "setHoldingMax",
        title: "Set Holding Max",
        description: "Set maximum holding multiplier (admin only)",
        inputs: [
          { name: "newHoldingMax", type: "uint256", placeholder: "Enter new holding max (uint256)", required: true }
        ],
        icon: "📈",
        category: "Admin Settings"
      },
      {
        name: "setLpRewardContract",
        title: "Set LP Reward Contract",
        description: "Set LP reward contract (admin only)",
        inputs: [
          { name: "newLpReward", type: "address", placeholder: "Enter new LP reward address", required: true }
        ],
        icon: "🏆",
        category: "Admin Settings"
      },
      {
        name: "setNewNftMarketPlace",
        title: "Set New NFT Market Place",
        description: "Set new NFT marketplace address (admin only)",
        inputs: [
          { name: "newNftMarketPlace", type: "address", placeholder: "Enter new NFT marketplace address", required: true }
        ],
        icon: "🎨",
        category: "Admin Settings"
      },
      {
        name: "setNewnHoldingNft",
        title: "Set New Holding NFT",
        description: "Set new holding NFT values (admin only)",
        inputs: [
          { name: "holdingNft0", type: "uint8", placeholder: "Enter holding NFT 0 (uint8)", required: true },
          { name: "holdingNft1", type: "uint8", placeholder: "Enter holding NFT 1 (uint8)", required: true },
          { name: "holdingNft2", type: "uint8", placeholder: "Enter holding NFT 2 (uint8)", required: true },
          { name: "holdingNft3", type: "uint8", placeholder: "Enter holding NFT 3 (uint8)", required: true },
          { name: "holdingNft4", type: "uint8", placeholder: "Enter holding NFT 4 (uint8)", required: true },
          { name: "holdingNft5", type: "uint8", placeholder: "Enter holding NFT 5 (uint8)", required: true },
          { name: "holdingNft6", type: "uint8", placeholder: "Enter holding NFT 6 (uint8)", required: true },
          { name: "holdingNft7", type: "uint8", placeholder: "Enter holding NFT 7 (uint8)", required: true }
        ],
        icon: "🎨",
        category: "Admin Settings"
      },
      {
        name: "setNftRewardContract",
        title: "Set NFT Reward Contract",
        description: "Set new NFT reward contract (admin only)",
        inputs: [
          { name: "newNftReward", type: "address", placeholder: "Enter new NFT reward address", required: true }
        ],
        icon: "🏆",
        category: "Admin Settings"
      },
      {
        name: "setRouterAndPair",
        title: "Set Router And Pair",
        description: "Set router and pair addresses (admin only)",
        inputs: [
          { name: "newRouter", type: "address", placeholder: "Enter new router", required: true },
          { name: "newPair", type: "address", placeholder: "Enter new pair", required: true }
        ],
        icon: "🔗",
        category: "Admin Settings"
      },
      // ✅ NEW: setTradexRedeem (was missing)
      {
        name: "setTradexRedeem",
        title: "Set Tradex Redeem",
        description: "Set new tradex redeem contract address (admin only)",
        inputs: [
          { name: "newTradexRedeem", type: "address", placeholder: "Enter new tradex redeem address", required: true }
        ],
        icon: "🔄",
        category: "Admin Settings"
      },
      {
        name: "setUpgradeCondition",
        title: "Set Upgrade Condition",
        description: "Set upgrade direct conditions (admin only)",
        inputs: [
          { name: "directCond0", type: "uint256", placeholder: "Enter direct condition 0 (uint256)", required: true },
          { name: "directCond1", type: "uint256", placeholder: "Enter direct condition 1 (uint256)", required: true },
          { name: "directCond2", type: "uint256", placeholder: "Enter direct condition 2 (uint256)", required: true },
          { name: "directCond3", type: "uint256", placeholder: "Enter direct condition 3 (uint256)", required: true },
          { name: "directCond4", type: "uint256", placeholder: "Enter direct condition 4 (uint256)", required: true },
          { name: "directCond5", type: "uint256", placeholder: "Enter direct condition 5 (uint256)", required: true },
          { name: "directCond6", type: "uint256", placeholder: "Enter direct condition 6 (uint256)", required: true }
        ],
        icon: "📊",
        category: "Admin Settings"
      },
      {
        name: "setUsdtToken",
        title: "Set USDT Token",
        description: "Set new USDT token address (admin only)",
        inputs: [
          { name: "newToken", type: "address", placeholder: "Enter new USDT address", required: true }
        ],
        icon: "💵",
        category: "Admin Settings"
      },
      {
        name: "setUserBlockRewardCondition",
        title: "Set User Block Reward Condition",
        description: "Set block reward condition for user (admin only)",
        inputs: [
          { name: "userAccount", type: "address", placeholder: "Enter user account address", required: true },
          { name: "status", type: "bool", placeholder: "Enter status (true/false)", required: true }
        ],
        icon: "🚫",
        category: "Admin Settings"
      },
      {
        name: "setUserExcludeRewardCondition",
        title: "Set User Exclude Reward Condition",
        description: "Set exclude reward condition for user (admin only)",
        inputs: [
          { name: "userAccount", type: "address", placeholder: "Enter user account address", required: true },
          { name: "status", type: "bool", placeholder: "Enter status (true/false)", required: true }
        ],
        icon: "❌",
        category: "Admin Settings"
      },
      {
        name: "setUserLevelHoldRequire",
        title: "Set User Level Hold Require",
        description: "Set user level hold requirement (admin only)",
        inputs: [
          { name: "newUserLevelHoldRequire", type: "uint256", placeholder: "Enter new hold requirement (uint256)", required: true }
        ],
        icon: "📋",
        category: "Admin Settings"
      },
      {
        name: "setlevelIncomeThresholds",
        title: "Set Level Income Thresholds",
        description: "Set level income thresholds (admin only)",
        inputs: [
          { name: "threshold0", type: "uint8", placeholder: "Enter threshold 0 (uint8)", required: true },
          { name: "threshold1", type: "uint8", placeholder: "Enter threshold 1 (uint8)", required: true },
          { name: "threshold2", type: "uint8", placeholder: "Enter threshold 2 (uint8)", required: true },
          { name: "threshold3", type: "uint8", placeholder: "Enter threshold 3 (uint8)", required: true },
          { name: "threshold4", type: "uint8", placeholder: "Enter threshold 4 (uint8)", required: true }
        ],
        icon: "📊",
        category: "Admin Settings"
      },
      {
        name: "setnewSaleNftDirectThresholds",
        title: "Set New Sale NFT Direct Thresholds",
        description: "Set new sale NFT direct thresholds (admin only)",
        inputs: [
          { name: "threshold0", type: "uint8", placeholder: "Enter threshold 0 (uint8)", required: true },
          { name: "threshold1", type: "uint8", placeholder: "Enter threshold 1 (uint8)", required: true },
          { name: "threshold2", type: "uint8", placeholder: "Enter threshold 2 (uint8)", required: true },
          { name: "threshold3", type: "uint8", placeholder: "Enter threshold 3 (uint8)", required: true },
          { name: "threshold4", type: "uint8", placeholder: "Enter threshold 4 (uint8)", required: true }
        ],
        icon: "📊",
        category: "Admin Settings"
      },
      {
        name: "subscribeOwner",
        title: "Subscribe Owner",
        description: "Subscribe multiple users (admin only)",
        inputs: [
          { name: "userAccount", type: "address[]", placeholder: "Enter user accounts (comma separated addresses)", required: true },
          { name: "referrer", type: "address[]", placeholder: "Enter referrers (comma separated addresses)", required: true },
          { name: "level", type: "uint8", placeholder: "Enter level (uint8)", required: true },
          { name: "isBlockBool", type: "bool", placeholder: "Enter block bool (true/false)", required: true }
        ],
        icon: "👑",
        category: "Admin Control"
      },
      {
        name: "resyncOwner",
        title: "Resync Owner",
        description: "Resync users from start to end index (admin only)",
        inputs: [
          { name: "startIndex", type: "uint256", placeholder: "Enter start index (uint256)", required: true },
          { name: "endIndex", type: "uint256", placeholder: "Enter end index (uint256)", required: true }
        ],
        icon: "🔄",
        category: "Admin Control"
      },
      {
        name: "recoverErc20",
        title: "Recover ERC20",
        description: "Recover ERC20 tokens (admin only)",
        inputs: [
          { name: "erc20Token", type: "address", placeholder: "Enter ERC20 token address", required: true },
          { name: "amount", type: "uint256", placeholder: "Enter amount (uint256)", required: true }
        ],
        icon: "🔄",
        category: "Admin Recovery"
      },
      {
        name: "recoverEth",
        title: "Recover Eth",
        description: "Recover ETH (admin only)",
        inputs: [
          { name: "amount", type: "uint256", placeholder: "Enter amount (uint256)", required: true }
        ],
        icon: "💎",
        category: "Admin Recovery"
      },
      {
        name: "setBulkPlanLimits",
        title: "Set Bulk Plan Limits",
        description: "Set limits for all 10 plans at once (admin only)",
        inputs: [
          { name: "newLimits", type: "uint256[]", placeholder: "Enter 10 limit values (comma separated)", required: true }
        ],
        icon: "📊",
        category: "Admin Settings"
      },
      {
        name: "newSetUp",
        title: "New Setup",
        description: "Run new setup configuration (admin only)",
        inputs: [],
        icon: "⚙️",
        category: "Admin Control"
      }
    ]
  };

  const connectWallet = async () => {
    setLoadingStates(prev => ({ ...prev, connect: true }));
    try {
      const acc = await loadWeb3();
      if (acc === "No Wallet") {
        toast.error("No Wallet Detected");
        setBtnTxt("Connect Wallet");
      } else if (acc === "Wrong Network") {
        toast.error("Please switch to opBNB Mainnet");
        setBtnTxt("Wrong Network");
      } else {
        setAccount(acc);
        setBtnTxt(acc.substring(0, 6) + '...' + acc.substring(acc.length - 4));
        toast.success("Connected to opBNB Mainnet");
        loadMatrixData();
      }
    } catch (error) {
      console.error("Connection error:", error);
      toast.error("Connection failed");
      setBtnTxt("Connect Wallet");
    } finally {
      setLoadingStates(prev => ({ ...prev, connect: false }));
    }
  };

  const getContract = () => {
    const web3 = getWeb3Instance();
    return new web3.eth.Contract(tradeXNftMatrixAbi, tradeXNftMatrix);
  };

  const getUsdtContract = () => {
    const web3 = getWeb3Instance();
    return new web3.eth.Contract(USDTAbi, USDT);
  };

  const loadMatrixData = useCallback(async () => {
    if (!account) return;
    try {
      const web3 = getWeb3Instance();
      const contract = getContract();
      const usdtContract = getUsdtContract();
      const [totalUsers, totalLevel, directIncomePercent, levelIncomePercent, paused, contractUsdtBalance, userUsdtBalance] = await Promise.all([
        contract.methods.totalUsers().call().catch(() => "0"),
        contract.methods.totalLevel().call().catch(() => "0"),
        contract.methods.directIncomePercent().call().catch(() => "0"),
        contract.methods.levelIncomePercent().call().catch(() => "0"),
        contract.methods.paused().call().catch(() => false),
        usdtContract.methods.balanceOf(tradeXNftMatrix).call().catch(() => "0"),
        usdtContract.methods.balanceOf(account).call().catch(() => "0")
      ]);
      setMatrixData({
        totalUsers: totalUsers.toString(),
        totalLevel: totalLevel.toString(),
        directIncomePercent: directIncomePercent.toString(),
        levelIncomePercent: levelIncomePercent.toString(),
        paused: paused,
        usdtBalance: parseFloat(web3.utils.fromWei(contractUsdtBalance.toString(), 'ether')).toFixed(2),
        userUsdtBalance: parseFloat(web3.utils.fromWei(userUsdtBalance.toString(), 'ether')).toFixed(2)
      });
    } catch (error) {
      console.error("Error loading matrix data:", error);
      toast.error("Failed to load matrix data");
    }
  }, [account]);

  useEffect(() => {
    if (account) {
      loadMatrixData();
    }
  }, [account, loadMatrixData]);

  const handleInputChange = (functionName, inputName, value) => {
    setFunctionInputs(prev => ({
      ...prev,
      [functionName]: {
        ...prev[functionName],
        [inputName]: value
      }
    }));
  };

  const executeReadFunction = async (functionData) => {
    if (!account) {
      toast.error("Please connect your wallet first");
      return;
    }
    const funcKey = functionData.name;
    setLoadingStates(prev => ({ ...prev, [funcKey]: true }));
    try {
      const contract = getContract();
      const inputs = functionInputs[funcKey] || {};
      const args = functionData.inputs.map(input => {
        const value = inputs[input.name];
        if (input.required && (!value || value.trim() === '')) {
          throw new Error(`${input.name} is required`);
        }
        if (input.type.includes('[]') && typeof value === 'string') {
          return value.split(',').map(v => v.trim());
        }
        return value || '';
      });
      const result = await contract.methods[functionData.name](...args).call();
      const formattedResult = functionData.formatOutput
        ? functionData.formatOutput(result)
        : JSON.stringify(result, (key, value) => typeof value === 'bigint' ? value.toString() : value, 2);
      setFunctionOutputs(prev => ({
        ...prev,
        [funcKey]: formattedResult
      }));
      toast.success("Read operation successful!");
    } catch (error) {
      console.error("Read error:", error);
      toast.error(error.message || "Read operation failed");
    } finally {
      setLoadingStates(prev => ({ ...prev, [funcKey]: false }));
    }
  };

  const executeWriteFunction = async (functionData) => {
    if (!account) {
      toast.error("Please connect your wallet first");
      return;
    }
    const funcKey = functionData.name;
    setLoadingStates(prev => ({ ...prev, [funcKey]: true }));
    try {
      const web3 = getWeb3Instance();
      const contract = getContract();
      const usdtContract = getUsdtContract();
      const inputs = functionInputs[funcKey] || {};

      let args = functionData.inputs.map(input => {
        let value = inputs[input.name];
        if (input.required && (!value || (typeof value === 'string' && value.trim() === ''))) {
          throw new Error(`${input.name} is required`);
        }
        if (input.type.includes('[]') && typeof value === 'string') {
          return value.split(',').map(v => v.trim());
        }
        if (input.type === 'bool') {
          return typeof value === 'boolean' ? value : String(value).toLowerCase() === 'true';
        }
        return value || '';
      });

      if (functionData.requiresApproval) {
        const level = args[1];
        const plan = await contract.methods.planInfo(level).call();
        const usdtAmount = plan.planPrice || plan[0];
        const allowance = await usdtContract.methods.allowance(account, tradeXNftMatrix).call();
        if (BigInt(allowance) < BigInt(usdtAmount)) {
          toast.info("Approving USDT...");
          await usdtContract.methods.approve(tradeXNftMatrix, usdtAmount).send({ from: account });
          toast.success("USDT Approved!");
        }
      }

      let processedArgs = args;
      const name = functionData.name;

      if (name === 'addNewPakage') {
        processedArgs = [args[0], [args[1], args[2], args[3], args[4]], args[5]];
      } else if (name === 'setlevelIncomeThresholds' || name === 'setnewSaleNftDirectThresholds') {
        processedArgs = [[args[0], args[1], args[2], args[3], args[4]]];
      } else if (name === 'setNewnHoldingNft') {
        processedArgs = [[args[0], args[1], args[2], args[3], args[4], args[5], args[6], args[7]]];
      } else if (name === 'setUpgradeCondition') {
        processedArgs = [[args[0], args[1], args[2], args[3], args[4], args[5], args[6]]];
      } else if (name === 'subscribeOwner') {
        processedArgs = [args[0], args[1], args[2], args[3]];
      } else if (name === 'setBulkPlanLimits') {
        // args[0] is already a parsed array from the includes('[]') check
        processedArgs = [args[0]];
      }
      // ✅ changeUserAddress: holdCycles is already parsed as array via includes('[]') above

      const tx = await contract.methods[functionData.name](...processedArgs).send({ from: account });
      toast.success(`Transaction successful! Hash: ${tx.transactionHash}`);
      loadMatrixData();
    } catch (error) {
      console.error("Write error:", error);
      toast.error(error.message || "Write operation failed");
    } finally {
      setLoadingStates(prev => ({ ...prev, [funcKey]: false }));
    }
  };

  const groupFunctionsByCategory = (functions) => {
    return functions.reduce((acc, func) => {
      const cat = func.category || 'Other';
      if (!acc[cat]) acc[cat] = [];
      acc[cat].push(func);
      return acc;
    }, {});
  };

  const renderFunctionCard = (func, isWrite = false, isAdmin = false) => {
    const funcKey = func.name;
    const inputs = functionInputs[funcKey] || {};
    const output = functionOutputs[funcKey];
    const isLoading = loadingStates[funcKey] || false;
    return (
      <div key={funcKey} className="col-lg-4 col-md-6 mb-4">
        <div className="card h-100 shadow-lg border-0" style={{
          borderRadius: '20px',
          background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.02))',
          backdropFilter: 'blur(15px)',
          border: '1px solid rgba(255, 255, 255, 0.1)'
        }}>
          <div className="card-body p-4 d-flex flex-column">
            <div className="d-flex align-items-center mb-3">
              <span className="fs-3 me-3">{func.icon}</span>
              <div>
                <h5 className="mb-1 text-white">{func.title}</h5>
                <small className="text-white-50">{func.description}</small>
              </div>
            </div>
            {func.inputs.map(input => (
              <div key={input.name} className="mb-3">
                <input
                  type="text"
                  className="form-control bg-dark border-0 text-white placeholder-white"
                  placeholder={input.placeholder}
                  value={inputs[input.name] || ''}
                  onChange={(e) => handleInputChange(funcKey, input.name, e.target.value)}
                  style={{ borderRadius: '12px', padding: '12px' }}
                />
              </div>
            ))}
            <button
              onClick={() => isWrite || isAdmin
                ? executeWriteFunction(func)
                : executeReadFunction(func)}
              disabled={isLoading}
              className="btn w-100 mt-auto"
              style={{
                background: isWrite || isAdmin
                  ? 'linear-gradient(135deg, #ff6b6b, #4ecdc4)'
                  : 'linear-gradient(135deg, #00ff88, #00ccff)',
                border: 'none',
                color: '#fff',
                borderRadius: '12px',
                padding: '12px',
                fontWeight: '600'
              }}
            >
              {isLoading ? 'Processing...' : (isWrite || isAdmin ? 'Execute Write' : 'Read')}
            </button>
            {output && (
              <div className="mt-3 p-3 rounded-3" style={{
                background: 'rgba(0, 255, 136, 0.1)',
                border: '1px solid rgba(0, 255, 136, 0.3)',
                overflow: 'auto',
                maxHeight: '200px'
              }}>
                <small className="text-white-50 d-block mb-2">Output:</small>
                <code className="text-white" style={{ whiteSpace: 'pre-wrap' }}>{output}</code>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="container-fluid min-vh-100 d-flex align-items-center justify-content-center p-4" style={{
      background: 'linear-gradient(135deg, #000428, #004e92)'
    }}>
      <div className="container text-center">
        <h1 className="mb-5 display-4 fw-bold" style={{
          background: 'linear-gradient(135deg, #00ff88, #00ccff)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent'
        }}>
          TradeXNFT Matrix Dashboard
        </h1>

        <div className="mb-5">
          <button
            onClick={connectWallet}
            disabled={loadingStates.connect}
            className="btn px-4 px-md-5 py-3 rounded-pill shadow-lg position-relative overflow-hidden"
            style={{
              background: account ?
                'linear-gradient(135deg, #00ff88, #00ccff)' :
                'linear-gradient(135deg, #ff6b6b, #4ecdc4)',
              border: 'none',
              color: account ? '#000' : '#fff',
              fontSize: 'clamp(0.9rem, 3vw, 1.1rem)',
              fontWeight: '700',
              transition: 'all 0.3s ease',
              minWidth: '160px',
              boxShadow: '0 4px 15px rgba(0, 0, 0, 0.2)',
              opacity: loadingStates.connect ? 0.7 : 1
            }}
          >
            {loadingStates.connect ? (
              <div className="d-flex align-items-center">
                <div className="spinner-border spinner-border-sm me-2" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
                Connecting...
              </div>
            ) : (
              <span className="position-relative">{btnTxt}</span>
            )}
          </button>
        </div>

        {account && (
          <div className="mt-4 p-3 rounded-4" style={{
            background: 'rgba(0, 255, 136, 0.1)',
            border: '1px solid rgba(0, 255, 136, 0.3)'
          }}>
            <div className="d-flex justify-content-center align-items-center gap-2">
              <span className="text-white-50 small">
                🔗 {account.substring(0, 6)}...{account.substring(account.length - 4)}
              </span>
              <span className="badge bg-success rounded-pill">Connected</span>
            </div>
          </div>
        )}

        {account && (
          <div className="row">
            <div className="col-12">
              <div className="card shadow-lg border-0 mb-4" style={{
                borderRadius: '24px',
                background: 'rgba(255, 255, 255, 0.05)',
                backdropFilter: 'blur(20px)',
                border: '1px solid rgba(255, 255, 255, 0.1)'
              }}>
                <div className="card-header border-0 p-4" style={{
                  borderRadius: '24px 24px 0 0',
                  background: 'transparent'
                }}>
                  <ul className="nav nav-pills justify-content-center flex-wrap gap-2" role="tablist">
                    {[
                      { key: 'overview', label: 'Overview', icon: '🏪', color: '#00ff88' },
                      { key: 'read', label: 'Read Functions', icon: '👁️', color: '#45b7d1' },
                      { key: 'write', label: 'Write Functions', icon: '📝', color: '#4ecdc4' },
                      { key: 'admin', label: 'Admin Functions', icon: '⚙️', color: '#ff6b6b' }
                    ].map(tab => (
                      <li key={tab.key} className="nav-item">
                        <button
                          className={`nav-link border-0 px-4 py-3 fw-bold position-relative overflow-hidden ${
                            activeTab === tab.key ? 'text-dark' : 'text-white-50'
                          }`}
                          onClick={() => setActiveTab(tab.key)}
                          style={{
                            borderRadius: '16px',
                            background: activeTab === tab.key ?
                              `linear-gradient(135deg, ${tab.color}, ${tab.color}80)` :
                              'rgba(255, 255, 255, 0.05)',
                            border: activeTab === tab.key ?
                              `1px solid ${tab.color}` :
                              '1px solid rgba(255, 255, 255, 0.1)',
                            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                            transform: activeTab === tab.key ? 'translateY(-2px)' : 'translateY(0)',
                            boxShadow: activeTab === tab.key ?
                              `0 8px 25px ${tab.color}40` : 'none'
                          }}
                        >
                          <span className="me-2 fs-5">{tab.icon}</span>
                          <span className="d-none d-md-inline">{tab.label}</span>
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="card-body p-4" style={{
                  background: 'rgba(0, 0, 0, 0.2)',
                  borderRadius: '0 0 24px 24px'
                }}>
                  {activeTab === 'overview' && (
                    <div className="row g-4">
                      <div className="col-lg-3 col-md-6">
                        <div className="card h-100 border-0" style={{
                          borderRadius: '20px',
                          background: 'linear-gradient(135deg, rgba(0, 255, 136, 0.15), rgba(69, 183, 209, 0.1))',
                          border: '1px solid rgba(0, 255, 136, 0.3)',
                          backdropFilter: 'blur(10px)'
                        }}>
                          <div className="card-body p-4 text-center">
                            <div className="fs-1 mb-3">👥</div>
                            <h4 className="text-white mb-2">{matrixData.totalUsers || '0'}</h4>
                            <p className="text-white-50 mb-0">Total Users</p>
                            <button
                              className="btn btn-sm mt-3 w-100"
                              onClick={() => executeReadFunction(matrixFunctions.readFunctions.find(f => f.name === 'totalUsers'))}
                              style={{ background: 'rgba(0, 255, 136, 0.2)', border: '1px solid #00ff88', color: '#00ff88' }}
                            >
                              🔄 Refresh
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-6">
                        <div className="card h-100 border-0" style={{
                          borderRadius: '20px',
                          background: 'linear-gradient(135deg, rgba(69, 183, 209, 0.15), rgba(107, 224, 215, 0.1))',
                          border: '1px solid rgba(69, 183, 209, 0.3)',
                          backdropFilter: 'blur(10px)'
                        }}>
                          <div className="card-body p-4 text-center">
                            <div className="fs-1 mb-3">🏆</div>
                            <h4 className="text-white mb-2">{matrixData.totalLevel || '0'}</h4>
                            <p className="text-white-50 mb-0">Total Level</p>
                            <button
                              className="btn btn-sm mt-3 w-100"
                              onClick={() => executeReadFunction(matrixFunctions.readFunctions.find(f => f.name === 'totalLevel'))}
                              style={{ background: 'rgba(69, 183, 209, 0.2)', border: '1px solid #45b7d1', color: '#45b7d1' }}
                            >
                              🔄 Refresh
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-6">
                        <div className="card h-100 border-0" style={{
                          borderRadius: '20px',
                          background: 'linear-gradient(135deg, rgba(107, 224, 215, 0.15), rgba(255, 170, 0, 0.1))',
                          border: '1px solid rgba(107, 224, 215, 0.3)',
                          backdropFilter: 'blur(10px)'
                        }}>
                          <div className="card-body p-4 text-center">
                            <div className="fs-1 mb-3">💰</div>
                            <h4 className="text-white mb-2">{matrixData.directIncomePercent || '0'}%</h4>
                            <p className="text-white-50 mb-0">Direct Income</p>
                            <button
                              className="btn btn-sm mt-3 w-100"
                              onClick={() => executeReadFunction(matrixFunctions.readFunctions.find(f => f.name === 'directIncomePercent'))}
                              style={{ background: 'rgba(107, 224, 215, 0.2)', border: '1px solid #6be0d7', color: '#6be0d7' }}
                            >
                              🔄 Refresh
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-6">
                        <div className="card h-100 border-0" style={{
                          borderRadius: '20px',
                          background: `linear-gradient(135deg, ${matrixData.paused ? 'rgba(255, 107, 107, 0.15)' : 'rgba(0, 255, 136, 0.15)'}, rgba(255, 170, 0, 0.1))`,
                          border: `1px solid ${matrixData.paused ? 'rgba(255, 107, 107, 0.3)' : 'rgba(0, 255, 136, 0.3)'}`,
                          backdropFilter: 'blur(10px)'
                        }}>
                          <div className="card-body p-4 text-center">
                            <div className="fs-1 mb-3">{matrixData.paused ? '⏸️' : '▶️'}</div>
                            <h4 className="text-white mb-2">{matrixData.paused ? 'PAUSED' : 'ACTIVE'}</h4>
                            <p className="text-white-50 mb-0">Contract Status</p>
                            <button
                              className="btn btn-sm mt-3 w-100"
                              onClick={() => executeReadFunction(matrixFunctions.readFunctions.find(f => f.name === 'paused'))}
                              style={{
                                background: matrixData.paused ? 'rgba(255, 107, 107, 0.2)' : 'rgba(0, 255, 136, 0.2)',
                                border: matrixData.paused ? '1px solid #ff6b6b' : '1px solid #00ff88',
                                color: matrixData.paused ? '#ff6b6b' : '#00ff88'
                              }}
                            >
                              🔄 Refresh
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="row g-4 mt-2">
                        <div className="col-lg-6 col-md-6">
                          <div className="card h-100 border-0" style={{
                            borderRadius: '20px',
                            background: 'linear-gradient(135deg, rgba(255, 170, 0, 0.15), rgba(255, 107, 107, 0.1))',
                            border: '1px solid rgba(255, 170, 0, 0.3)',
                            backdropFilter: 'blur(10px)'
                          }}>
                            <div className="card-body p-4 text-center">
                              <div className="fs-1 mb-3">💰</div>
                              <h4 className="text-white mb-2">{matrixData.usdtBalance || '0.00'} USDT</h4>
                              <p className="text-white-50 mb-0">Contract Balance</p>
                              <button
                                className="btn btn-sm mt-3 w-100"
                                onClick={loadMatrixData}
                                style={{ background: 'rgba(255, 170, 0, 0.2)', border: '1px solid #ffaa00', color: '#ffaa00' }}
                              >
                                🔄 Refresh
                              </button>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-6">
                          <div className="card h-100 border-0" style={{
                            borderRadius: '20px',
                            background: 'linear-gradient(135deg, rgba(0, 255, 136, 0.15), rgba(69, 183, 209, 0.1))',
                            border: '1px solid rgba(0, 255, 136, 0.3)',
                            backdropFilter: 'blur(10px)'
                          }}>
                            <div className="card-body p-4 text-center">
                              <div className="fs-1 mb-3">💼</div>
                              <h4 className="text-white mb-2">{matrixData.userUsdtBalance || '0.00'} USDT</h4>
                              <p className="text-white-50 mb-0">Your Balance</p>
                              <button
                                className="btn btn-sm mt-3 w-100"
                                onClick={loadMatrixData}
                                style={{ background: 'rgba(0, 255, 136, 0.2)', border: '1px solid #00ff88', color: '#00ff88' }}
                              >
                                🔄 Refresh
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {activeTab === 'read' && (
                    <div>
                      <div className="d-flex justify-content-between align-items-center mb-4">
                        <h4 className="mb-0 text-info">👁️ Read Functions</h4>
                        <small className="text-white-50">
                          {matrixFunctions.readFunctions.length} functions available
                        </small>
                      </div>
                      {Object.entries(groupFunctionsByCategory(matrixFunctions.readFunctions)).map(([category, funcs]) => (
                        <div key={category} className="mb-5">
                          <h5 className="mb-3 text-white-50 d-flex align-items-center">
                            <span className="me-2">{category}</span>
                            <span className="badge bg-secondary rounded-pill">{funcs.length}</span>
                          </h5>
                          <div className="row">
                            {funcs.map(func => renderFunctionCard(func, false, false))}
                          </div>
                        </div>
                      ))}
                    </div>
                  )}

                  {activeTab === 'write' && (
                    <div>
                      <h4 className="mb-4" style={{ color: '#4ecdc4' }}>📝 Write Functions</h4>
                      {Object.entries(groupFunctionsByCategory(matrixFunctions.writeFunctions)).map(([category, funcs]) => (
                        <div key={category} className="mb-5">
                          <h5 className="mb-3 text-white-50">{category}</h5>
                          <div className="row">
                            {funcs.map(func => renderFunctionCard(func, true, false))}
                          </div>
                        </div>
                      ))}
                    </div>
                  )}

                  {activeTab === 'admin' && (
                    <div>
                      <h4 className="mb-4 text-danger">⚙️ Admin Functions</h4>
                      <div className="alert alert-warning">
                        <strong>⚠️ Warning:</strong> These functions are restricted to contract owner/admin only.
                      </div>
                      {Object.entries(groupFunctionsByCategory(matrixFunctions.adminFunctions)).map(([category, funcs]) => (
                        <div key={category} className="mb-5">
                          <h5 className="mb-3 text-white-50">{category}</h5>
                          <div className="row">
                            {funcs.map(func => renderFunctionCard(func, true, true))}
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}